module.exports = __webpack_public_path__ + "img/pic-4-2.c9a6c829.png";